/* eslint-disable @typescript-eslint/no-explicit-any */

export default class BaseAdapter {
  protected stringify(value: any) {
    return typeof value !== 'string' ? JSON.stringify(value) : value;
  }

  protected parse(value: string | null) {
    if (typeof value !== 'string') {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }
}
